import { normaliseConfidence } from "./normaliserUtils";

export default function normaliseAssets(data)
{
    if (!data)
    {
        return [];
    }

    let assetList = data;

    if (!Array.isArray(assetList) && Array.isArray(data.assets))
    {
        assetList = data.assets;
    }

    if (!Array.isArray(assetList) && Array.isArray(data.detections))
    {
        assetList = data.detections;
    }

    if (!Array.isArray(assetList))
    {
        return [];
    }

    return assetList.map(function(asset, index)
    {
		return {

		    id:
		        asset.id != null
		            ? asset.id
		            : index + 1,

		    type:
		        asset.type ||
		        asset.label ||
		        asset.category ||
		        asset.name ||
		        "Unknown Asset",

		    confidence:
		        normaliseConfidence(
		            asset.confidence
		        ),

		    condition:
		        asset.condition ||
		        asset.assetCondition ||
		        null,

		    observation:
		        asset.observation ||
		        asset.notes ||
		        asset.description ||
		        null,

		    recommendation:
		        asset.recommendation ||
		        asset.maintenanceRecommendation ||
		        null,

		    x: asset.x,
		    y: asset.y,

		    x1: asset.x1,
		    y1: asset.y1,
		    x2: asset.x2,
		    y2: asset.y2,

		    width: asset.width,
		    height: asset.height,

		    thumbnail: asset.thumbnail

		};
    });
}